.noAccountInvite {
	display: flex;
	flex-direction: column;

	.sub {
		font-weight: 600;
		letter-spacing: 0.01em;
		text-transform: uppercase;
		font-size: var(--text-caption);
		color: var(--color-text-silent);
	}
}

.expiry {
	&[data-expired="true"] {
		font-weight: 600;
		color: var(--color-error-foreground);
	}
}
